import { render, staticRenderFns } from "./commoditymanage.vue?vue&type=template&id=6b8a7e7a&"
import script from "./commoditymanage.vue?vue&type=script&lang=js&"
export * from "./commoditymanage.vue?vue&type=script&lang=js&"
import style0 from "./commoditymanage.vue?vue&type=style&index=0&id=6b8a7e7a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports